import { DetailedHTMLProps, HTMLAttributes } from 'react';
import Image from 'next/image';
import cn from 'classnames';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import styles from './lets-link-idea.module.css';
import idea from '../../public/letslink/idea/idea.png';
import {
  Container,
  Htag,
  HtagAlign,
  HtagVariant,
  Paragraph,
} from '../../components';

export interface LetsLinkIdeaProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {}

export default function LetsLinkIdea({
  className,
  ...props
}: LetsLinkIdeaProps) {
  return (
    <section className={cn(className, styles.idea)} {...props}>
      <Container variant="container_small">
        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <Htag
            tag="h2"
            className={styles.idea_title}
            variant={HtagVariant.h2}
            align={HtagAlign.center}
          >
            main idea
          </Htag>
        </AnimationOnScroll>
        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <Paragraph className={styles.idea_text}>
            LinkApp helps you to meet new people, manage relationships, organize
            events, find things to do and communicate in large groups on the go.
            With LinkApp, you can host and micromanage your party with ease (or
            find something to do on the map if you’re bored), get a cute date
            for the night while you’re at the mall, stay in the loop on what
            your friends are doing through the map, or talk with your
            neighbourhood through a GeoChat.
          </Paragraph>
        </AnimationOnScroll>
        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <div className={styles.idea_image}>
            <Image
              alt="Linkapp map preview"
              src={idea}
              width={977}
              height={384}
            />
          </div>
        </AnimationOnScroll>
      </Container>
    </section>
  );
}
